import { render } from "./TagInfoDialog.vue?vue&type=template&id=0a7c194d&scoped=true"
import script from "./TagInfoDialog.vue?vue&type=script&lang=js"
export * from "./TagInfoDialog.vue?vue&type=script&lang=js"

import "./TagInfoDialog.vue?vue&type=style&index=0&id=0a7c194d&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7c194d"]])

export default __exports__